module.exports = __webpack_public_path__ + "static/media/6.bf4ca8f1.png";